module.exports = __webpack_public_path__ + "img/fashion.08a7f62c.jpg";